module.exports = __webpack_public_path__ + "static/media/onboarding-welcome.f9ad5383.png";